import { render, staticRenderFns } from "./passengerDetails.vue?vue&type=template&id=4abf86d6&scoped=true&"
import script from "./passengerDetails.vue?vue&type=script&lang=js&"
export * from "./passengerDetails.vue?vue&type=script&lang=js&"
import style0 from "./passengerDetails.vue?vue&type=style&index=0&id=4abf86d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abf86d6",
  null
  
)

export default component.exports